import * as React from 'react';

import Modal from 'react-bootstrap/Modal';
import { CustomButton, Textfield } from '../../_common';

interface AddEditModalProps {
    show: boolean;
    setShow: (flag: boolean) => void;
    saveChanges: (data: any) => void;
    form?: any;
}

const proppantDto = {
    proppantName: '',
    extSystemName: 'JDE',
    extSystemReference: '',
};

const AddEditProppant = ({ show, setShow, saveChanges, form: existingForm }: AddEditModalProps): React.ReactElement => {
    const [form, setForm]: any = React.useState({ ...proppantDto });
    const [formErrors, setFormErrrors]: any = React.useState({});

    React.useEffect(() => {
        if (show) {
            setForm(existingForm || { ...proppantDto });
        } else {
            setForm({ ...proppantDto });
        }
        setFormErrrors({});
    }, [show]);

    const handleFormChange = (event: any) => {
        const { name, value } = event.target;
        setForm({
            ...form,
            [name]: value,
        });
    };

    const validateForm = () => {
        const errors = {};

        if (!form.proppantName) {
            errors['proppantName'] = 'Proppant Name is required';
        }

        if (!form.extSystemName) {
            errors['extSystemName'] = 'Ext System Name is required';
        }
        if (!form.extSystemReference) {
            errors['extSystemReference'] = 'Ext System Reference is required';
        }

        return {
            isValid: Object.keys(errors).length === 0,
            errors,
        };
    };

    const handleSaveChanges = () => {
        setFormErrrors({});
        const { isValid, errors } = validateForm();

        if (!isValid) {
            setFormErrrors(errors);
            return;
        }

        saveChanges({ ...proppantDto, ...form });
        setShow(false);
    };

    return (
        <Modal show={show} onHide={() => setShow(false)}>
            <Modal.Header closeButton>
                <Modal.Title>{`${form.proppantId ? 'Update' : 'Create'}`} Proppant</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Textfield
                    label="Proppant Name"
                    name="proppantName"
                    value={form.proppantName}
                    required
                    error={formErrors.proppantName}
                    helperText={formErrors.proppantName}
                    onChange={handleFormChange}
                    maxLength={50}
                />

                <Textfield
                    label="Ext System Name"
                    name="extSystemName"
                    error={formErrors.extSystemName}
                    helperText={formErrors.extSystemName}
                    value={form.extSystemName}
                    onChange={handleFormChange}
                    required
                    maxLength={50}
                    disabled
                />
                <Textfield
                    label="JDE ID"
                    name="extSystemReference"
                    error={formErrors.extSystemReference}
                    helperText={formErrors.extSystemReference}
                    value={form.extSystemReference}
                    onChange={handleFormChange}
                    required
                    maxLength={50}
                />
            </Modal.Body>
            <Modal.Footer>
                <CustomButton
                    title="Close"
                    isBordered
                    onClick={() => setShow(false)}
                    additionalStyle={'Grid-View-Btn'}
                />

                <CustomButton title="Save" isBordered onClick={handleSaveChanges} additionalStyle={'Grid-View-Btn'} />
            </Modal.Footer>
        </Modal>
    );
};

export default AddEditProppant;
